// extracted by mini-css-extract-plugin
export default {"List":"UnfinishedRevision_List__QaYx4","CreateButton":"UnfinishedRevision_CreateButton__mPQpF"};